import {
  Grid,
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from '@material-ui/core';
import withStyles from '@material-ui/styles/withStyles';

const SchematicModal = ({
  classes,
  componentName,
  isOpen,
  onCancel,
  onDelete,
}) => {
  return (
    <Dialog
      open={isOpen}
      aria-labelledby="schematic-dialog-title"
      onClose={onCancel}
    >
      <Grid className={classes.header}>
        <Grid container alignItems="center">
          <Grid item xs>
            <Typography variant="body1" id="schematic-dialog-title">
              Delete component?
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <DialogContent className={classes.content}>
        Are you sure you want to delete the <b>{componentName}</b>? This action
        is irreversible.
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} variant="text">
          Cancel
        </Button>
        <Button onClick={onDelete} color="primary" variant="contained">
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const styles = (theme) => ({
  header: {
    padding: theme.spacing(3),
  },
  content: {
    padding: `0px ${theme.spacing(3)}px`,
    paddingBottom: theme.spacing(3),
  },
});

export default withStyles(styles)(SchematicModal);
